'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keyMirror = require('react-utils/keyMirror');

var _keyMirror2 = _interopRequireDefault(_keyMirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InvitedActionTypes = (0, _keyMirror2.default)({
  TOKEN_VALIDATED: null
});

exports.default = InvitedActionTypes;
module.exports = exports['default'];